<template>
  <div>
    <form class="form-signin">
      <div class="form-group" @click.prevent="onConfirmRegistration">
        <h2>Confirm Registration</h2>
      </div>
      <div v-if="isErr" class="alert alert-danger">{{ isErr }}</div>
      <div class="form-group">
        <label class="control-label">Confirmation Code</label>
        <input
          id="confirmationCode"
          type="text"
          maxlength="50"
          class="form-control"
          v-model="confirmationCode"
        />
      </div>
      <div class="form-group">
        <button
          @click="onConfirmRegistration()"
          id="confirmRegistration"
          type="button"
          class="btn btn-info btn-block"
        >Confirm</button>
      </div>
      <p>
        Can't find your code?
        <a>
          <router-link to="/resendCode">
            <i class="fa fa-fw fa-group"></i> Resend Code
          </router-link>
        </a>
        <a>
          <router-link to="/register">
            <i class="fa fa-fw fa-group"></i> Register
          </router-link>
        </a>
        <a>
          <router-link to="/login">
            <i class="fa fa-fw fa-user"></i> Login
          </router-link>
        </a>
      </p>
    </form>
  </div>
</template>

<style lang="css">
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "ConfirmRegistration",
  components: {},
  data() {
    return {
      confirmationCode: ""
    };
  },
  computed: {
    ...mapState(["confirmError"]),
    isErr: function() {
      return this.confirmError;
    }
  },
  methods: {
    async onConfirmRegistration() {
      console.log("onConfirmRegistration");
      let store = this.$store;
      let router = this.$router;
      let code = this.confirmationCode;
      let email = this.$route.params.email;

      await store.dispatch("confirm", { email, code });

      console.log("confirmError: ", store.state.confirmError);
      if (!store.state.confirmError) {
        router.push("/login");
      }
    }
  }
};
</script>